export default __webpack_public_path__ + "media/images/chevron-down-e7d7bd47d1e14daca66cb20e9585f5fe.svg";